import React from "react";
import authStore from "../../authStore";
import { observer } from "mobx-react";
import AccountCircleIcon from "@material-ui/icons/AccountCircleRounded";

const CurrentUserProfilePic = observer(
  class CurrentUserProfilePic extends React.Component {
    profileImageDidNotLoad() {
      this.setState({
        photoURL:
          "https://themango.co/wp-content/uploads/2018/03/Mango-Default-Profile-Pic.png"
      });
    }

    render() {
      const user = authStore.user.get();
      let style = {
        borderRadius: "50%",
        height: this.props.height
      };

      if (this.props._style) {
        Object.assign(style, this.props._style);
      }

      if (user) {
        const wrapperStyle = this.props.showScore
          ? { position: "relative" }
          : {};

        return (
          <div style={wrapperStyle}>
            <img
              alt="Profile"
              src={user.photoURL}
              style={style}
              onError={this.profileImageDidNotLoad.bind(this)}
            />

            {this.props.showScore && user.score ? (
              <span
                className="score"
                style={{
                  backgroundColor: "green",
                  borderRadius: "50%",
                  color: "white",
                  padding: "0.2rem",
                  fontSize: "0.8rem",
                  border: "0.1rem solid white",
                  position: "absolute",
                  bottom: "0",
                  left: "-5px"
                }}
              >
                {user.score}
              </span>
            ) : null}
          </div>
        );
      } else {
        return <AccountCircleIcon fontSize="large" style={style} />;
      }
    }
  }
);

export default CurrentUserProfilePic;
